import { render, staticRenderFns } from "./crossTenantDialogChangeHistory.vue?vue&type=template&id=1065f187&"
import script from "./crossTenantDialogChangeHistory.vue?vue&type=script&lang=js&"
export * from "./crossTenantDialogChangeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1065f187')) {
      api.createRecord('1065f187', component.options)
    } else {
      api.reload('1065f187', component.options)
    }
    module.hot.accept("./crossTenantDialogChangeHistory.vue?vue&type=template&id=1065f187&", function () {
      api.rerender('1065f187', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/crossTenantDialogChangeHistory.vue"
export default component.exports